// removed by extract-text-webpack-plugin
module.exports = {"main":"_1lKRQI84KPewSfw4vwnQb5"};


//////////////////
// WEBPACK FOOTER
// ./components/ReceiptTable.module.css
// module id = 2369
// module chunks = 1